import * as React from "react";

export const Full: React.FC = ({ children }) => <div className="col-span-2">{children}</div>;
